define('app-CarouselWidget/main',['./settings', 'text!../libs/owlCarousel/owl.carousel.min.css', 'text!../libs/owlCarousel/owl.theme.default.min.css', '../app-CarouselComponent/modules', 'owlCarousel'],
    function (settings, styles, style2, modules) {
        return {
            run: function () {
                var container = $(settings.container);

                if (container.length === 0) {
                    window.log('No Gallery Widgets found.  app-CarouselWidget will not be available.');
                    return;
                }


                container.first()
                    .append('<style>' + styles + style2 + '</style>');

                container.find(".owl-carousel").each(function () {
                    var carousel = $(this);
                    var totalProducts = carousel.find('div.widget').length;

                    if (totalProducts > 0) {
                        var startPos = Math.round(totalProducts / 2) - 1;
                        var is2x2Layout = carousel.hasClass('product-list-2x2-widget');
                        var is4x2Layout = carousel.hasClass('product-list-4x2-widget');
                        
                        carousel.owlCarousel({
                            center: false,
                            margin: 15,
                            loop: false,
                            responsiveClass: true,
                            navRewind: false,
                            nav: true,
                            dots: true,
                            dotsEach: true,
                            mouseDrag: true,
                            touchDrag: true,
                            autoplay: false,
                            autoplayTimeout: 5000,
                            autoplayHoverPause: false,
                            responsive: {
                                0: {
                                    startPosition: 0,
                                    items: 1
                                },
                                480: {
                                    startPosition: is2x2Layout ? 0 : 1,
                                    items: is2x2Layout ? 1 : 1
                                },
                                768: {
                                    startPosition: is2x2Layout ? 0 : 1,
                                    items: is2x2Layout ? 2 : 1
                                },
                                992: {
                                    items: is4x2Layout ? 2 : 3,
                                    startPosition: is2x2Layout || is4x2Layout ? 0 : 1
                                },
                                1200: {
                                    items: is4x2Layout ? 3 : is2x2Layout ? 4 : totalProducts < 5 ? totalProducts : 4,
                                    startPosition: is2x2Layout || is4x2Layout ? 0 : 1
                                }
                            }
                        });
                    }
                    if ($(window).width() <= 767) {
                        $(this).on('changed.owl.carousel', function () {

                            var next = $(this).find('.owl-item.active').next('.owl-item').next('.owl-item');
                            if (!$(next).find('img').hasClass('b-loaded')) {
                                var url = $(next).find('img').attr('data-src');
                                $(next).find('img').attr('src', url).addClass('b-loaded').removeAttr('data-src');
                            }
                        });

                        $(".owl-dot").click(function (event) {
                            var currentDot = $(this).index();
                            var current = $(carousel).find('.owl-item')[currentDot];
                            if (!$(current).find('img').hasClass('b-loaded')) {
                                var url = $(current).find('img').attr('data-src');
                                $(current).find('img').attr('src', url).addClass('b-loaded').removeAttr('data-src');
                            }
                            var next = $(current).next('.owl-item');
                            if (!$(next).find('img').hasClass('b-loaded')) {
                                var url = $(next).find('img').attr('data-src');
                                $(next).find('img').attr('src', url).addClass('b-loaded').removeAttr('data-src');
                            }
                        });
                    }


                    modules.sliderControls(carousel);


                    carousel.on('resized.owl.carousel', function (event) {

                        $('.owl-carousel').each(function () {
                            var carousel = $(this);
                            ResizeHeight(carousel);
                        });
                    })
                    ResizeHeight(carousel);
                    carousel.css('visibility', 'visible');

                    carousel.on('translated.owl.carousel', function (event) {
                        modules.sliderControls(carousel);
                    });
                });

                function ResizeHeight(carousel) {
                    var currentCarousel = $(carousel);

                    if ($(currentCarousel).is(':visible')) {
                        var maxHeight = -1;
                        var widgetInner = $(currentCarousel).find('.widgetInner');
                        widgetInner.each(function () {
                            $(this).removeAttr('style');

                            var height = $(this).height();

                            maxHeight = maxHeight > height ? maxHeight : height;
                        });

                        widgetInner.height(maxHeight);
                        if ($('body').hasClass('cruise')) {
                            modules.sliderControls(carousel);
                        }
                    }
                }

                window.loadedModules('app-CarouselWidget');
            }
        }
    });
